import { z } from 'zod';
import { cloudSubmission } from '@rill/contracts/cloud-run';

export type RunDraft = { practice?: { missionId: string; version: 1 }; voiceDraft?: true; id: string; url: string; prompt: string; savedAt: number; landingVariant?: 'browser_check_v1'; preset?: 'Sauce Demo' | 'TodoMVC' | 'The Internet'; homepageExample?: string; mode?: 'browse' | 'interact'; interactionConfirmed?: boolean; allowedWriteOrigins?: string[]; expectation?: string; account?: string };
const key = 'rill:cloud-run-draft';
const lifetime = 30 * 60 * 1000;
export function readRunDraft(): RunDraft | null {
  try {
    const raw = JSON.parse(sessionStorage.getItem(key) ?? 'null');
    if (!raw || typeof raw.savedAt !== 'number' || Date.now() - raw.savedAt > lifetime) return null;
    const schema = raw.voiceDraft === true ? cloudSubmission.extend({ prompt: z.string().max(2000) }) : cloudSubmission;
    const parsed = schema.safeParse({ id: raw.id, url: raw.url, prompt: raw.prompt, ...(raw.mode ? {mode: raw.mode} : {}), ...(raw.interactionConfirmed !== undefined ? {interactionConfirmed: raw.interactionConfirmed} : {}), ...(raw.allowedWriteOrigins ? {allowedWriteOrigins:raw.allowedWriteOrigins} : {}), ...(raw.expectation ? {expectation:raw.expectation} : {}), ...(raw.account ? {account:raw.account} : {}) });
    return parsed.success ? { ...parsed.data, ...(raw.voiceDraft === true ? {voiceDraft: true as const} : {}), savedAt: raw.savedAt, ...(raw.landingVariant === 'browser_check_v1' ? {landingVariant:raw.landingVariant} : {}), ...(['Sauce Demo', 'TodoMVC', 'The Internet'].includes(raw.preset) ? {preset:raw.preset} : {}), ...(typeof raw.homepageExample === 'string' ? {homepageExample:raw.homepageExample} : {}) } : null;
  } catch { return null; }
}
export function saveRunDraft(draft: RunDraft) {
  // A failed write must keep the visitor on the form, rather than lose their task in OAuth.
  sessionStorage.setItem(key, JSON.stringify(draft));
}
export function clearRunDraft(id: string) {
  try { if (readRunDraft()?.id === id) sessionStorage.removeItem(key); } catch { /* Submission already succeeded. */ }
}

// Checkout can outlast the normal composer lifetime. Restore only a valid saved
// draft, for explicit review in the composer; this never submits the task.
export function restorePurchaseRunDraft() {
  try {
    const raw = JSON.parse(sessionStorage.getItem('rill:purchase-run-draft') ?? 'null');
    if (!raw || typeof raw.savedAt !== 'number' || Date.now() - raw.savedAt > 86_400_000) return;
    const previous = sessionStorage.getItem(key);
    saveRunDraft({ ...raw, savedAt: Date.now() });
    if (!readRunDraft()) {
      if (previous) sessionStorage.setItem(key, previous); else sessionStorage.removeItem(key);
    }
    sessionStorage.removeItem('rill:purchase-run-draft');
  } catch { /* Navigation and paid access do not depend on browser storage. */ }
}
